module.exports = __webpack_public_path__ + "static/media/norutec_10_14.ba2a7fea.png";